'use client';
import { createContext } from '../create-context.mjs';

const [SegmentGroupProvider, useSegmentGroupContext] = createContext({
  name: "SegmentGroupContext",
  hookName: "useSegmentGroupContext",
  providerName: "<SegmentGroupProvider />"
});

export { SegmentGroupProvider, useSegmentGroupContext };
